<template>
    <!-- 答题练习 -->
    <div
        class="answer-box"
    >
        <div :class="['title', isEn ? 'title-en' : '']">
            答题练习
        </div>
        <div class="answer-info">
            <div class="answer-info-item">
                <div class="top">
                    <span>
                        {{totalLearnNum}}
                    </span>
                    次
                </div>
                <div class="bottom">
                    累计练习
                </div>
            </div>
            <div class="answer-info-item">
                <div class="top">
                    <span>
                        {{questionThreeStarsRate}}
                    </span>
                    %
                </div>
                <div class="bottom">
                    题目三星率
                </div>
            </div>
        </div>

        <div
            class="challenge-container"
            v-for="(item, index) in questionResultList"
            :key="index"
        >
            <div class="challenge-header">
                <img class="challenge-icon" :src="phaseMap[item.phaseType]" alt="">
                <span>{{item.phaseTypeName}}</span>
            </div>

            <div class="challenge-grid">
                <div
                    v-for="(item1, index1) in item.questionStarsList"
                    :key="index1"
                    class="challenge-item"
                >
                    <div :class="['circle']">{{index1 + 1}}</div>
                    <div class="stars">
                        <img
                            class="star"
                            v-for="(item2, index2) in item1.starsNum"
                            :key="index2"
                            src="https://i.gsxcdn.com/2714714560_b3p5x2yj.png"
                            alt=""
                        >
                        <img
                            class="star"
                            v-for="(item2, index2) in 3 - item1.starsNum"
                            :key="index2"
                            src="https://i.gsxcdn.com/2714703762_l4kgfqxm.png"
                            alt=""
                        >
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="js">
import {Options, Vue} from 'vue-class-component';

@Options({
    components: {
    },
    mounted() {
    },
    props: {
        pageData: {
            type: Object,
            default() {
                return {};
            }
        },
        isEn: {
            type: Boolean,
            default() {
                return false;
            }
        },
    },
    data() {
        const {totalLearnNum, questionThreeStarsRate, questionResultList} = this.pageData.answerQuestionInfo;
        return {
            totalLearnNum,
            questionThreeStarsRate,
            questionResultList,
            phaseMap: {
                93: 'https://i.gsxcdn.com/2714723108_um41wf2s.png',
                // 理解巩固
                63: 'https://i.gsxcdn.com/2714985605_fratc1qk.png',
                // 课前预习
                89: 'https://i.gsxcdn.com/2714988470_a3sctlfz.png',
                // 巩固练习
                90: 'https://i.gsxcdn.com/2714990555_dvhizz1y.png',
            }
        };
    },
    computed: {

    },
    watch: {

    },
})
export default class Speech extends Vue {

}
</script>

<style lang="scss" scoped>
.answer-box {
    margin-top: .8rem;
    padding-bottom: .37rem;
    width: 9.15rem;
    background: #FFFFFF;
    box-shadow: 0 .05rem .21rem 0 rgba(118,118,118,.15);
    border-radius: .43rem;
    display: flex;
    flex-direction: column;
    align-items: center;

    .title {
        margin-top: -.245rem;
        margin-bottom: .69rem;
        display: flex;
        padding-top: .35rem;
        justify-content: center;
        font-size: .45rem;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        color: #FFFFFF;
        width: 4.53rem;
        height: 1.07rem;
        background: url('https://i.gsxcdn.com/2713148460_bp1opt2e.png') 0 0 no-repeat;
        background-size: cover;
        box-sizing: border-box;
    }

    .title-en {
        background: url('https://i.gsxcdn.com/2725359897_t1e029yp.png') 0 0 no-repeat;
        background-size: cover;
    }

    .answer-info {
        display: flex;
        justify-content: center;
        width: 77%;
        margin-bottom: .85rem;

        .answer-info-item {
            width: 50%;
            text-align: center;

            .top {
                font-family: PingFangSC, PingFang SC;
                font-weight: 600;
                font-size: .32rem;
                color: #FF781E;
                line-height: .43rem;
                font-style: normal;

                span {
                    font-size: .85rem;
                    line-height: 1.07rem;
                    text-align: justify;
                }
            }

            .bottom {
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: .32rem;
                color: #333333;
                line-height: .43rem;
            }
        }
    }

    .challenge-container {
        margin-bottom: .21rem;
        width: 100%;
        box-sizing: border-box;

        .challenge-header {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: .32rem; // 对应图片上标出的大小
            font-size: .4rem;
            font-weight: 600;
            color: #0B0B0B;

            .challenge-icon {
                width: .75rem; // 设置图标宽度
                height: .75rem;
                margin-right: .16rem; // 图标与文字的间距
            }
        }

        .challenge-grid {
            display: flex;
            flex-wrap: wrap;
            margin: 0 .11rem;

            .challenge-item {
                width: 25%; // 每行展示三个元素
                text-align: center;
                margin-bottom: .48rem;

                .circle {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: .95rem;
                    height: .95rem;
                    background: #FFFFFF;
                    border: .03rem solid #EFEFEF;
                    border-radius: 50%;
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 600;
                    font-size: .37rem;
                    color: #333333;
                    margin: auto;
                    margin-bottom: .05rem;
                }

                .stars {
                    display: flex;
                    justify-content: center;

                    .star {
                        width: .43rem; // 星星图标的大小
                        height: .43rem;
                    }
                }
            }
        }
    }
}
</style>
